export const FILTER_TASKLIST = "FILTER_TASKLIST";

export const filterTasklist = (filter) => {
    return {
        type: FILTER_TASKLIST,
        filter,
    };
};
